export const BRAINTREE = 'braintree';
export const PADDLE = 'paddle';
export const SETAPP = 'setapp'; // is used for testing only
